<!--用户中心-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="er-page">
            <!--子页面：返回首页-->
            <div class="tab-row" v-if="activeItem!=='0'">
                <div class="back-pill" @click="changeItem('0')">
                    <el-icon :size="16"><Back /></el-icon>
                    <span>返回</span>
                </div>
                <div class="page-title">{{pageTitle}}</div>
            </div>
            <!--首页仪表盘-->
            <div class="module-content" v-if="activeItem==='0'">
                <div class="uc-dashboard">
                    <!--左侧：用户信息 + 菜单 + 快捷入口 -->
                    <div class="uc-left">
                        <div class="uc-profile-card">
                            <div class="uc-user cursor" @click="changeItem('1')">
                                <img class="uc-avatar" :src="userInfo.avatar" alt="">
                                <div class="uc-user-info">
                                    <div class="uc-name-row">
                                        <span class="uc-name">{{userInfo.trueName}}</span>
                                        <span class="uc-badge" v-if="userInfo.roleName">
                                            <img class="uc-badge-icon" src="../../assets/screen/Group93.png" alt="">
                                            {{userInfo.roleName}}
                                        </span>
                                    </div>
                                    <div class="uc-school">{{userInfo.orgName || '--'}} | {{userInfo.periodName || ''}}{{userInfo.subjectName || ''}}教师</div>
                                </div>
                            </div>
                            <div class="uc-stats">
                                <div class="uc-stat">
                                    <div class="num">{{statsInfo.trainCount}}</div>
                                    <div class="label">培训任务</div>
                                </div>
                                <div class="uc-stat">
                                    <div class="num">{{statsInfo.studyCount}}</div>
                                    <div class="label">教研任务</div>
                                </div>
                                <div class="uc-stat">
                                    <div class="num">{{statsInfo.eduCount}}</div>
                                    <div class="label">教科研任务</div>
                                </div>
                            </div>
                        </div>
                        <div class="uc-menu">
                            <div class="uc-menu-item" @click="changeItem('9')">
                                <img class="uc-menu-icon" src="../../assets/screen/user1.png" alt="">
                                <div class="uc-menu-name">我的关注</div>
                                <img class="uc-menu-more" src="../../assets/screen/more.png" alt="">
                            </div>
                            <div class="uc-menu-item" @click="changeItem('3')">
                                <img class="uc-menu-icon" src="../../assets/screen/user2.png" alt="">
                                <div class="uc-menu-name">我的任务</div>
                                <img class="uc-menu-more" src="../../assets/screen/more.png" alt="">
                            </div>
                            <div class="uc-menu-item" @click="changeItem('2')">
                                <img class="uc-menu-icon" src="../../assets/screen/user3.png" alt="">
                                <div class="uc-menu-name">我的消息</div>
                                <img class="uc-menu-more" src="../../assets/screen/more.png" alt="">
                            </div>
                        </div>
                        <div class="uc-quick">
                            <div class="uc-quick-item" @click="changeItem('6')">
                                <img class="uc-quick-icon" src="../../assets/screen/Group112.png" alt="">
                                <div class="uc-quick-name">我的档案</div>
                            </div>
                            <div class="uc-quick-item" @click="changeItem('8')">
                                <img class="uc-quick-icon" src="../../assets/screen/Group113.png" alt="">
                                <div class="uc-quick-name">课程收藏</div>
                            </div>
                            <div class="uc-quick-item" @click="changeItem('10')">
                                <img class="uc-quick-icon" src="../../assets/screen/Group114.png" alt="">
                                <div class="uc-quick-name">我的证书</div>
                            </div>
                        </div>
                    </div>
                    <!--右侧：成长轨迹 + 专业成长 + 教师画像-->
                    <div class="uc-right">
                        <div class="uc-track-card">
                            <div class="uc-card-head">
                                <span class="uc-card-title title-green">成长轨迹</span>
                                <span class="uc-card-sub">教·研·训·心，全程赋能</span>
                            </div>
                            <div class="uc-track-list">
                                <div class="uc-track-item" @click="goDevelop('1')">
                                    <img class="uc-track-icon" src="../../assets/screen/center1.png" alt="">
                                    <div class="uc-track-name">成长明细</div>
                                </div>
                                <div class="uc-track-item" @click="goDevelop('2')">
                                    <img class="uc-track-icon" src="../../assets/screen/center2.png" alt="">
                                    <div class="uc-track-name">师资培训</div>
                                </div>
                                <div class="uc-track-item" @click="goDevelop('3')">
                                    <img class="uc-track-icon" src="../../assets/screen/center3.png" alt="">
                                    <div class="uc-track-name">教学教研</div>
                                </div>
                                <div class="uc-track-item" @click="goDevelop('4')">
                                    <img class="uc-track-icon" src="../../assets/screen/center4.png" alt="">
                                    <div class="uc-track-name">教科研</div>
                                </div>
                            </div>
                        </div>
                        <div class="uc-two">
                            <div class="uc-half uc-zy" @click="changeItem('11')">
                                <!-- <div class="uc-card-title title-brown">专业成长</div>
                                <div class="uc-card-sub">见证专业高光时刻</div> -->
                                <!-- <img class="uc-half-bg" src="../../assets/screen/zycz.png" alt=""> -->
                            </div>
                            <div class="uc-half uc-hx" @click="todoTip">
                                <!-- <div class="uc-card-title title-blue">教师画像</div>
                                <div class="uc-card-sub">数据刻画成长画像</div> -->
                                <!-- <img class="uc-half-bg" src="../../assets/screen/jshx.png" alt=""> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--子页面-->
            <div class="module-content" v-else>
                <!-- 个人资料 -->
                <user-info v-if="activeItem==='1'" />
                <!-- 消息中心 -->
                <msg-center v-if="activeItem==='2'" />
                <!-- 任务中心 -->
                <task-center v-if="activeItem==='3'" />
                <!-- 收藏中心/课程收藏 -->
                <collection-center v-if="activeItem==='4'||activeItem==='8'" />
                <!-- 我的关注 -->
                <follow-center v-if="activeItem==='5'||activeItem==='9'" />
                <!-- 教师档案 -->
                <teacher-archives v-if="activeItem==='6'" />
                <!-- 我的证书 -->
                <my-certs v-if="activeItem==='10'" />
                <!-- 专业成长 -->
                <my-honors v-if="activeItem==='11'" />
                <!-- 成长中心 -->
                <develop-center v-if="activeItem==='7'" :item-num="developItem" />
            </div>
        </div>
    </div>
</template>
<script>
import { serviceWebUrl } from "@/utils/global"
import {timestampToTime} from "@/utils/date";
import {developTrain, developStudy, developEdu} from "@/api/admin/userCenter";
import homeHead from "@/components/homeHead.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import userInfo from "@/components/userCenter/userInfo.vue";
import msgCenter from "@/components/userCenter/msgCenter.vue";
import taskCenter from "@/components/userCenter/taskCenter.vue";
import collectionCenter from "@/components/userCenter/collectCenter.vue";
import followCenter from "@/components/userCenter/followCenter.vue";
import teacherArchives from "@/components/userCenter/teacherArchives.vue";
import developCenter from "@/components/userCenter/developCenter.vue";
import courseCollection from "@/components/userCenter/courseCollection.vue";
import myCerts from "@/components/userCenter/myCerts.vue";
import myHonors from "@/components/userCenter/myHonors.vue";
export default {
    components: {
        dataEmpty,
        homeHead,
        userInfo,
        msgCenter,
        taskCenter,
        collectionCenter,
        followCenter,
        teacherArchives,
        developCenter,
        myCerts,
        myHonors,
        courseCollection
    },
    name: "homeUserCenter",
    data() {
        return {
            serviceWebUrl,
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "homeUserCenter",
            activeItem:"0",
            activeMode:"page",
            developItem:"1",
            userInfo: JSON.parse(this.$storage.get("userInfo")) || {},
            statsInfo: {
                trainCount: '--',
                studyCount: '--',
                eduCount: '--',
            },
        }
    },
    computed: {
        pageTitle(){
            if (this.activeItem==='7'){
                return {'1':'成长明细','2':'师资培训','3':'教学教研','4':'教科研'}[this.developItem] || '';
            }
            return {'1':'个人资料','2':'消息中心','3':'任务中心','4':'课程收藏','8':'课程收藏','5':'我的关注','9':'我的关注','6':'教师档案','10':'我的证书','11':'专业成长'}[this.activeItem] || '';
        },
        jumpParams(){
            return this.$store.state.params.jumpParams;
        }
    },
    watch: {
        //已在用户中心页时，点击头部消息/任务图标仅更新 jumpParams，需监听后切换模块
        jumpParams(newValue){
            if (newValue && newValue.activeItem){
                this.activeItem = newValue.activeItem;
            }
        }
    },
    created() {
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
        if (this.$store.state.params.jumpParams.activeItem){
            this.activeItem = this.$store.state.params.jumpParams.activeItem;
        }
        this.getStatsInfo();
    },
    methods: {
        //统计：培训任务、教研任务、教科研任务数量（与成长明细各模块数量一致）
        getStatsInfo(){
            developTrain().then(res => {
                if (res.data.code===1){
                    this.statsInfo.trainCount = res.data.data.amount;
                }
            })
            developStudy().then(res => {
                if (res.data.code===1){
                    this.statsInfo.studyCount = res.data.data.amount;
                }
            })
            developEdu().then(res => {
                if (res.data.code===1){
                    this.statsInfo.eduCount = res.data.data.amount;
                }
            })
        },
        changeItem(item){
            this.activeItem = item;
            this.activeMode = this.pageMode;
        },
        changeMode(mode){
            this.activeMode = mode;
        },
        //成长轨迹：进入成长中心并定位到对应子标签
        goDevelop(item){
            this.developItem = item;
            this.changeItem('7');
        },
        todoTip(){
            this.$message({message:'敬请期待', type:'info'});
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.er-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}
/*返回首页*/
.tab-row {
    display: flex;
    align-items: center;
    gap: 16px;
    max-width: 1840px;
    margin: 0 auto 24px;
}
.back-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 38px;
    padding: 0 22px;
    box-sizing: border-box;
    font-size: 16px;
    color: #fff;
    background: #29a8f0;
    border: none;
    border-radius: 19px;
    cursor: pointer;
}
.page-title {
    margin-left: 8px;
    font-size: 22px;
    font-weight: bold;
    color: #1f4e79;
}
.module-content {
    max-width: 1840px;
    margin: 0 auto;
    min-height: calc(100vh - 182px);
    box-sizing: border-box;
}
/*仪表盘*/
.uc-dashboard {
    display: flex;
    gap: 24px;
    align-items: stretch;
}
/*左侧*/
.uc-left {
    width: 380px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: linear-gradient(180deg, #42b0f5 0%, #1d7ee0 100%);
    border-radius: 24px;
    padding: 20px;
    box-sizing: border-box;
}
.uc-profile-card {
    background: linear-gradient(135deg, #2f9ff2 0%, #1668c9 100%);
    border-radius: 16px;
    padding: 20px;
    box-sizing: border-box;
}
.uc-user {
    display: flex;
    align-items: center;
}
.uc-avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
    background: #fff;
}
.uc-user-info {
    margin-left: 14px;
    min-width: 0;
}
.uc-name-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}
.uc-name {
    font-size: 20px;
    font-weight: bold;
    color: #fff;
}
.uc-badge {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    height: 20px;
    line-height: 20px;
    padding: 0 8px;
    background: linear-gradient(90deg, #ffd87e 0%, #ffb84d 100%);
    border-radius: 10px;
    font-size: 12px;
    color: #8a5a00;
    white-space: nowrap;
}
.uc-badge-icon {
    width: 12px;
    height: 12px;
}
.uc-school {
    margin-top: 8px;
    font-size: 13px;
    color: rgba(255,255,255,.85);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.uc-stats {
    display: flex;
    margin-top: 20px;
    border-top: 1px solid rgba(255,255,255,.25);
    padding-top: 16px;
}
.uc-stat {
    flex: 1;
    text-align: center;
    & + .uc-stat {
        border-left: 1px solid rgba(255,255,255,.25);
    }
    .num {
        font-size: 22px;
        font-weight: bold;
        color: #fff;
    }
    .label {
        margin-top: 4px;
        font-size: 13px;
        color: rgba(255,255,255,.85);
    }
}
/*左侧菜单*/
.uc-menu {
    display: flex;
    flex-direction: column;
}
.uc-menu-item {
    display: flex;
    align-items: center;
    height: 52px;
    cursor: pointer;
    & + .uc-menu-item {
        border-top: 1px solid rgba(255,255,255,.25);
    }
}
.uc-menu-icon {
    width: 24px;
    height: 24px;
    margin-right: 12px;
}
.uc-menu-name {
    font-size: 16px;
    color: #fff;
}
.uc-menu-more {
    width: 14px;
    height: 14px;
    margin-left: auto;
}
/*快捷入口*/
.uc-quick {
    display: flex;
    gap: 12px;
}
.uc-quick-item {
    flex: 1;
    background: #fff;
    border-radius: 16px;
    padding: 16px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
}
.uc-quick-icon {
    width: 56px;
    height: 56px;
    object-fit: contain;
}
.uc-quick-name {
    margin-top: 8px;
    font-size: 15px;
    font-weight: bold;
    color: #333;
}
/*右侧*/
.uc-right {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.uc-track-card {
    background: linear-gradient(135deg, #e9f9dc 0%, #d6f2c2 100%);
    border-radius: 24px;
    padding: 24px;
    box-sizing: border-box;
}
.uc-card-head {
    display: flex;
    align-items: baseline;
    gap: 16px;
}
.uc-card-title {
    font-size: 22px;
    font-weight: bold;
}
.title-green {
    color: #2f7a1c;
}
.title-brown {
    color: #8a5a13;
}
.title-blue {
    color: #1c4f9e;
}
.uc-card-sub {
    font-size: 14px;
    color: #6b7a63;
}
.uc-track-list {
    display: flex;
    gap: 16px;
    margin-top: 20px;
}
.uc-track-item {
    flex: 1;
    background: #fff;
    border-radius: 16px;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
}
.uc-track-icon {
    width: 64px;
    height: 64px;
    object-fit: contain;
}
.uc-track-name {
    margin-top: 10px;
    font-size: 15px;
    font-weight: bold;
    color: #333;
}
/*专业成长/教师画像*/
.uc-two {
    display: flex;
    gap: 24px;
    flex: 1;
}
.uc-half {
    position: relative;
    flex: 1;
    border-radius: 24px;
    padding: 24px;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
}
.uc-zy {
    background-image: url("../../assets/screen/zycz.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;

}
.uc-hx {
    background-image: url("../../assets/screen/jshx.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.uc-half .uc-card-sub {
    margin-top: 8px;
    color: #8a7a5a;
}
.uc-hx .uc-card-sub {
    color: #6a7a9a;
}
.uc-half-bg {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 100%;
    object-fit: contain;
    pointer-events: none;
}
</style>
